import { requestApi } from "../utils/requestApi";
import { GET } from "../types/httpMethod";

export const useIsUserExists = () => {
  const isUserExist = async (email: string) => {
    return requestApi(GET, "/users/exist", {}, false, true, undefined, { email });
  };
  return { isUserExist };
};
